/**
 * INFINITY LIFE 2.0 — Google OAuth & Account Management Modal
 */

import { store } from '../state.js';
import { api, showToast } from '../api.js';

export function renderAuthModal() {
  const { modals, user, theme } = store.get();

  if (!modals.auth) {
    return `<div id="auth-modal-container"></div>`;
  }

  const isLogged = !!user;

  return `
    <div class="modal-overlay open" id="auth-modal-overlay">
      <div class="modal-card" style="max-width: 480px;">
        <div class="modal-header">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="font-size: 1.3rem;">${isLogged ? '👤' : '🔑'}</span>
            <h2 class="modal-title">${isLogged ? 'Minha Conta' : 'Acessar o Infinity Life'}</h2>
          </div>
          <button class="btn-close" id="btn-close-auth-modal">✕</button>
        </div>

        ${!isLogged ? renderLoginView() : renderProfileView(user, theme)}
      </div>
    </div>
  `;
}

function renderLoginView() {
  const isLocal = typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  return `
    <div style="text-align: center; padding: 10px 0;">
      <img src="/icons/icon-192.svg" alt="Infinity Life" style="width: 54px; height: 54px; margin-bottom: 12px;" />
      <h3 style="font-size: 1.25rem; font-weight: 800; margin-bottom: 6px;">Acessar o Infinity Life</h3>
      <p style="font-size: 0.85rem; color: var(--text-muted); line-height: 1.5; margin-bottom: 22px;">
        Sua central completa de vida pessoal e profissional.
      </p>

      <!-- Google Sign In Container (Renderizado dinamicamente pelo Google SDK) -->
      <div id="google-signin-container" style="display: flex; justify-content: center; margin-bottom: 14px; min-height: 44px;">
        <button class="btn-secondary" id="btn-google-login-action" style="width: 100%; justify-content: center; padding: 12px; font-weight: 700;">
          <svg width="18" height="18" viewBox="0 0 18 18" style="margin-right: 8px;">
            <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.616z"/>
            <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"/>
            <path fill="#FBBC05" d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707s.102-1.167.282-1.707V4.961H.957C.347 6.175 0 7.55 0 9s.348 2.825.957 4.039l3.007-2.332z"/>
            <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.961L3.964 7.293C4.672 5.166 6.656 3.58 9 3.58z"/>
          </svg>
          Entrar com Google
        </button>
      </div>

      <!-- Informação ou Guia de Ajuda do Google OAuth (se client_id ainda não estiver configurado) -->
      <div id="google-setup-notice" style="display: none; background: rgba(99, 102, 241, 0.1); border: 1px solid rgba(99, 102, 241, 0.25); border-radius: var(--radius-md); padding: 12px; margin-bottom: 16px; text-align: left; font-size: 0.8rem; color: var(--text-secondary); line-height: 1.5;">
        <div style="font-weight: 700; color: #818cf8; margin-bottom: 4px;">ℹ️ Google Client ID não configurado no servidor</div>
        Para ativar o botão de 1 clique do Google para todos os membros, cadastre seu <strong>Google Client ID</strong> no <code>api/config.local.php</code>.<br />
        <span style="color: var(--text-primary); font-weight: 600;">Enquanto isso, você pode entrar abaixo como Proprietário com seu e-mail e chave mestra!</span>
      </div>

      <!-- Divisor -->
      <div style="display: flex; align-items: center; gap: 10px; margin: 18px 0; color: var(--text-muted); font-size: 0.78rem;">
        <span style="flex: 1; height: 1px; background: var(--border-subtle);"></span>
        <span>OU ACESSO DO PROPRIETÁRIO</span>
        <span style="flex: 1; height: 1px; background: var(--border-subtle);"></span>
      </div>

      <!-- Formulário Direto de Acesso do Proprietário (Chave Mestra) -->
      <form id="owner-login-form" style="text-align: left; display: flex; flex-direction: column; gap: 12px;">
        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label" style="font-size: 0.78rem;">Seu E-mail de Proprietário</label>
          <input type="email" id="owner-login-email" class="form-input" 
                 placeholder="ex: contato@infinitgrupo.com.br" 
                 required style="font-size: 0.88rem; padding: 10px 12px;" />
        </div>

        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label" style="font-size: 0.78rem;">Chave de Acesso (Migration Key do config.local.php)</label>
          <input type="password" id="owner-login-key" class="form-input" 
                 placeholder="Sua migration_key (ex: infinity_secret_2026)" 
                 required style="font-size: 0.88rem; padding: 10px 12px;" />
        </div>

        <button type="submit" class="btn-primary" id="btn-owner-direct-login" style="width: 100%; justify-content: center; padding: 11px; margin-top: 4px; font-weight: 700;">
          <span>👑</span> <span>Entrar como Proprietário</span>
        </button>
      </form>

      ${isLocal ? `
        <!-- Atalho Rápido Local Dev -->
        <div style="margin-top: 18px; padding-top: 14px; border-top: 1px dashed var(--border-subtle);">
          <button class="btn-secondary" id="btn-dev-login-action" style="width: 100%; justify-content: center; font-size: 0.8rem; padding: 8px;">
            <span>⚡</span> <span>Atalho Local Dev (1 Clique)</span>
          </button>
        </div>
      ` : ''}

      <div style="font-size: 0.72rem; color: var(--text-muted); margin-top: 20px;">
        Acesso seguro protegido por criptografia de ponta a ponta.
      </div>
    </div>
  `;
}

function renderProfileView(user, theme) {
  const isOwner = user.is_owner || user.role === 'owner';

  return `
    <div>
      <!-- Profile Header -->
      <div style="display: flex; align-items: center; gap: 14px; margin-bottom: 20px; padding-bottom: 16px; border-bottom: 1px solid var(--border-subtle);">
        ${user.avatar_url ? `
          <img src="${user.avatar_url}" alt="${user.name}" style="width: 52px; height: 52px; border-radius: 50%;" />
        ` : `
          <div style="width: 52px; height: 52px; border-radius: 50%; background: var(--primary); display: flex; align-items: center; justify-content: center; font-size: 1.4rem; font-weight: 700; color: #ffffff;">
            ${(user.name || 'U').charAt(0).toUpperCase()}
          </div>
        `}
        <div>
          <div style="font-size: 1.15rem; font-weight: 700; color: var(--text-primary);">${escapeHtml(user.name)}</div>
          <div style="font-size: 0.85rem; color: var(--text-muted);">${escapeHtml(user.email)}</div>
          <div style="margin-top: 6px; display: flex; gap: 6px; flex-wrap: wrap;">
            <span class="badge ${isOwner ? 'badge-urgent' : 'badge-high'}" style="font-weight: 700;">
              ${isOwner ? '👑 Proprietário (Acesso Vitalício Total)' : (user.plan === 'lifetime' ? '👑 Membro Fundador Vitalício' : (user.plan === 'annual' ? '⭐ Membro VIP Anual' : '💼 Plano Pro Mensal'))}
            </span>
            <span class="badge badge-low">
              ✓ Recursos Desbloqueados
            </span>
          </div>
        </div>
      </div>


      <!-- Preferences -->
      <div style="margin-bottom: 24px;">
        <h4 style="font-size: 0.95rem; margin-bottom: 12px;">Preferências Pessoais</h4>

        <div class="form-group">
          <label class="form-label">Tema Visual</label>
          <select id="user-theme-select" class="form-select">
            <option value="dark" ${theme === 'dark' ? 'selected' : ''}>🌙 Modo Escuro (Obsidian)</option>
            <option value="light" ${theme === 'light' ? 'selected' : ''}>☀️ Modo Claro</option>
          </select>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Fuso Horário</label>
            <input type="text" class="form-input" value="${escapeHtml(user.timezone || 'America/Sao_Paulo')}" readonly />
          </div>
          <div class="form-group">
            <label class="form-label">Moeda Padrão</label>
            <input type="text" class="form-input" value="${escapeHtml(user.currency || 'BRL')}" readonly />
          </div>
        </div>
      </div>

      <!-- Compliance & Actions -->
      <div style="display: flex; flex-direction: column; gap: 10px;">
        <button class="btn-secondary" id="btn-export-my-data" style="justify-content: center;">
          <span>📥</span> <span>Exportar Meus Dados (JSON - LGPD)</span>
        </button>

        <button class="btn-secondary" id="btn-logout" style="justify-content: center; color: var(--rose-accent);">
          <span>🚪</span> <span>Encerrar Sessão (Logout)</span>
        </button>

        ${!isOwner ? `
          <button class="btn-secondary" id="btn-delete-account" style="justify-content: center; font-size: 0.8rem; color: var(--text-muted);">
            <span>⚠️</span> <span>Excluir Minha Conta Definitivamente</span>
          </button>
        ` : ''}
      </div>
    </div>
  `;
}

function escapeHtml(str) {
  if (!str) return '';
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

export function attachAuthModalEvents(container) {
  const closeBtn = container.querySelector('#btn-close-auth-modal');
  const overlay = container.querySelector('#auth-modal-overlay');

  const close = () => store.toggleModal('auth', false);

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });
  }

  // Dev Login
  const devLoginBtn = container.querySelector('#btn-dev-login-action');
  if (devLoginBtn) {
    devLoginBtn.addEventListener('click', async () => {
      try {
        const res = await api.devLogin('admin@infinitylife.local', 'Infinity Owner');
        if (res.success) {
          localStorage.setItem('infinity_token', res.data.token);
          store.updateUser(res.data.user);
          showToast('Conectado como Proprietário com sucesso!', 'success');
          close();
          window.dispatchEvent(new CustomEvent('infinity:refresh-data'));
        }
      } catch (err) {
        showToast(err.message, 'error');
      }
    });
  }

  // Inicializar Google Identity Services automaticamente se o Client ID estiver presente
  api.getAuthConfig().then((cfg) => {
    if (cfg?.success && cfg.google_client_id && window.google?.accounts?.id) {
      try {
        window.google.accounts.id.initialize({
          client_id: cfg.google_client_id,
          callback: async (response) => {
            try {
              const res = await api.googleLogin(response.credential);
              if (res.success) {
                localStorage.setItem('infinity_token', res.data.token);
                store.updateUser(res.data.user);
                showToast('Login com Google realizado com sucesso!', 'success');
                close();
                window.dispatchEvent(new CustomEvent('infinity:refresh-data'));
              }
            } catch (err) {
              showToast(err.message, 'error');
            }
          },
          auto_select: false,
        });

        const signinContainer = container.querySelector('#google-signin-container');
        if (signinContainer) {
          signinContainer.innerHTML = '';
          window.google.accounts.id.renderButton(signinContainer, {
            theme: 'filled_blue',
            size: 'large',
            text: 'signin_with',
            shape: 'pill',
            width: 320,
            logo_alignment: 'left',
          });
        }
      } catch (gErr) {
        console.warn('Google Sign-In SDK initialization error:', gErr);
      }
    }
  }).catch(() => {});

  // Google Login Fallback Click
  const googleBtn = container.querySelector('#btn-google-login-action');
  if (googleBtn) {
    googleBtn.addEventListener('click', () => {
      const notice = container.querySelector('#google-setup-notice');
      if (notice) {
        notice.style.display = notice.style.display === 'none' ? 'block' : 'none';
      }
      showToast('Cadastre o Google Client ID no config.local.php ou use o Acesso do Proprietário abaixo!', 'info');
    });
  }

  // Owner Direct Login Form
  const ownerForm = container.querySelector('#owner-login-form');
  if (ownerForm) {
    ownerForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = container.querySelector('#owner-login-email').value.trim();
      const key = container.querySelector('#owner-login-key').value.trim();

      if (!email || !key) {
        showToast('Preencha seu e-mail e chave de acesso.', 'warning');
        return;
      }

      const submitBtn = container.querySelector('#btn-owner-direct-login');
      if (submitBtn) submitBtn.disabled = true;

      try {
        const res = await api.ownerLogin(email, key);
        if (res.success) {
          localStorage.setItem('infinity_token', res.data.token);
          store.updateUser(res.data.user);
          showToast('Login de Proprietário realizado com sucesso!', 'success');
          close();
          window.dispatchEvent(new CustomEvent('infinity:refresh-data'));
        }
      } catch (err) {
        showToast(err.message, 'error');
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  }

  // Theme change in profile
  const themeSelect = container.querySelector('#user-theme-select');
  if (themeSelect) {
    themeSelect.addEventListener('change', (e) => {
      store.setTheme(e.target.value);
    });
  }

  // Export Data
  const exportBtn = container.querySelector('#btn-export-my-data');
  if (exportBtn) {
    exportBtn.addEventListener('click', async () => {
      try {
        const res = await api.exportData();
        const blob = new Blob([JSON.stringify(res, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `infinity-life-backup-${new Date().toISOString().split('T')[0]}.json`;
        a.click();
        URL.revokeObjectURL(url);
        showToast('Exportação de dados concluída!', 'success');
      } catch (err) {
        showToast(err.message, 'error');
      }
    });
  }

  // Logout
  const logoutBtn = container.querySelector('#btn-logout');
  if (logoutBtn) {
    logoutBtn.addEventListener('click', async () => {
      try {
        await api.logout();
        localStorage.removeItem('infinity_token');
        store.updateUser(null);
        showToast('Sessão encerrada com sucesso.', 'info');
        close();
        window.dispatchEvent(new CustomEvent('infinity:refresh-data'));
      } catch (err) {
        showToast(err.message, 'error');
      }
    });
  }

  // Delete account
  const deleteBtn = container.querySelector('#btn-delete-account');
  if (deleteBtn) {
    deleteBtn.addEventListener('click', async () => {
      const confirmText = prompt("Para confirmar a exclusão irreversível de sua conta e todos os dados, digite exatamente: EXCLUIR MINHA CONTA");
      if (confirmText) {
        try {
          await api.deleteAccount(confirmText);
          localStorage.removeItem('infinity_token');
          store.updateUser(null);
          showToast('Conta excluída com sucesso.', 'info');
          close();
          window.dispatchEvent(new CustomEvent('infinity:refresh-data'));
        } catch (err) {
          showToast(err.message, 'error');
        }
      }
    });
  }
}
